// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3107) return "static/chunks/3107.ae868fb6c5ecc7a3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"174":"239c2f7e86e43cd2","1852":"d6651459dda36f3d","3924":"e9b75a4501d0ff47"}[chunkId] + ".js";
};